import React from 'react';
import {
  Grid, makeStyles, Box, Hidden,
} from '@material-ui/core';
import Widget from 'views/motorcycle_rental/components/widget/Widget';
import Filters from 'views/motorcycle_rental/components/filters/Filters';
import { getFiltersProps } from 'views/motorcycle_rental/utils/helpers';

const useStyles = makeStyles((theme) => ({
  widgetFiltersWrapper: {
    borderTop: `1px solid ${theme.palette.grey[100]}`,
    borderBottom: `1px solid ${theme.palette.grey[100]}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 4px 8px rgba(0,0,0,0.12)',
    // stick on scroll
    position: '-webkit-sticky',
    // eslint-disable-next-line no-dupe-keys
    position: 'sticky',
    top: '0',
    zIndex: '3',
    height: theme.spacing(8),
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      height: theme.spacing(9.75),
    },
  },
  widgetFiltersContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 2),
      '& .MuiGrid-item': {
        // minWidth: theme.spacing(18),
      },
    },
  },
  fullHeight: {
    height: '100%',

  },
  widgetContainer: {
    flex: '0 0 53%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flex: '1',

    },
  },
  filtersContainer: {
    flex: '0 0 47%',
  },
}));

const GeoWidgetAndFilters = (props) => {
  const { rentalData, handleFieldChange, translatedType } = props;
  const classes = useStyles();
  const filtersProps = getFiltersProps(rentalData, handleFieldChange, translatedType);

  return (
    <Box className={classes.widgetFiltersWrapper}>
      <Grid className={classes.widgetFiltersContainer}>
        <Grid item className={`${classes.fullHeight} ${classes.widgetContainer}`}>
          <Widget rentalData={rentalData} handleFieldChange={handleFieldChange} />
        </Grid>
        <Hidden mdDown>
          <Grid item className={`${classes.fullHeight} ${classes.filtersContainer}`}>
            <Filters data={filtersProps} />
          </Grid>
        </Hidden>
      </Grid>
    </Box>
  );
};
export default GeoWidgetAndFilters;
